import { ApolloProvider } from '@apollo/client/react'
import { createRoot } from 'react-dom/client'
import ReactPixelImport from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { RouterProvider } from 'react-router-dom'
import { ParallaxProvider } from 'react-scroll-parallax'
import './index.css'
import router from './routes'
import { ThemeProvider } from './theme/ThemeProvider'
import { client } from './utils/apolloClient'
const container = document.getElementById('root')

const ReactPixel =
  (ReactPixelImport as unknown as { default?: typeof ReactPixelImport }).default ??
  ReactPixelImport

const MEASUREMENT_ID = 'G-PLJ38NNYWB'
ReactGA.initialize(MEASUREMENT_ID)
ReactPixel.init('824661057103241')
ReactPixel.pageView()

if (!container) {
  throw new Error('Root container element with id "root" not found')
}

createRoot(container).render(
  <ParallaxProvider>
    <ThemeProvider>
      <ApolloProvider client={client}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </ThemeProvider>
  </ParallaxProvider>
)
